import HtmlDiff from 'htmldiff-js';
import {
  PrefaceComparison,
} from './preface_comparison';
import { DraftPreface } from 'views/App/Portal/Policy/_types/manuals/draft';


export default class prefaceComparer {
  static compare = (source: DraftPreface, target: DraftPreface) => {
    const sourcePreface = this.scrubPreface(source);
    const targetPreface = this.scrubPreface(target);
    const results: PrefaceComparison = {
      ...source,
      ...target,
      content: HtmlDiff.execute(sourcePreface.content, targetPreface.content),
      title: HtmlDiff.execute(sourcePreface.title, targetPreface.title),
      comparison: '',
      diffs: [],
    }

    return results;
  }

  static scrubPreface = (preface: DraftPreface) => {
    if (!preface) return preface;
    preface.content = this.scrubContent(preface.content);
    return preface;
  }

  static scrubContent = (content: string) => {
    const ctr = document.createElement('div');
    ctr.innerHTML = content;
    const badEls = ctr.querySelectorAll('lexindex');
    badEls.forEach((x) => x.remove());
    const links = ctr.querySelectorAll('a');
    links.forEach((l) => {
      if (l.href.startsWith('xref://') || l.href.startsWith('s3://')) l.href = '';
    })
    if (content !== ctr.innerHTML) {
      // console.log('scrubbed', [ctr.innerHTML, content])
    }
    return ctr.innerHTML;
  }

  static getTitleText = (title: string) => {
    const div = document.createElement('div');
    div.innerHTML = title;
    return div.innerText;
  }

}